var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBungalow = function SvgBungalow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Bungalow")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bungalow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-house-2@24x24",
    transform: "translate(34.000000, 42.000000)",
    stroke: "#212121",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,19.5 L8,63.5 L30.3333333,63.5 L30.3333333,44.25 C30.3333333,38.1743333 35.3322778,33.25 41.5,33.25 C47.6677222,33.25 52.6666667,38.1743333 52.6666667,44.25 L52.6666667,63.5 L75,63.5 L75,19.5",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 64,
    x2: 82,
    y2: 64,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    points: "41 0.5 82 20.5 0 20.5"
  })))));
};
export default SvgBungalow;